export default "__VITE_ASSET__a7bcfc79__"